import React, { FC, useRef, useEffect, useContext } from 'react'
import QueryContext from '../Utils/queryContext'

import Highcharts from 'highcharts/highcharts'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'
import HighchartsReact from 'highcharts-react-official'
import styled from 'styled-components'
import { ChartOptions } from '../ChartOptions'

highchartsMore(Highcharts)
solidGauge(Highcharts)

interface Props {
    event?: any
    config: LiveWidgetConfig
    height: number
    width: number
}

const SolidGauge: FC<Props> = ({ event, config, height, width }: Props): JSX.Element => {
    const chartRef = useRef()
    const { valueContext } = useContext(QueryContext)
    const { theme } = valueContext
    const Coptions = React.useMemo(() => ChartOptions(event, config, theme, height, width), [
        event,
        config,
        theme,
        height,
        width
    ])

    useEffect(() => {
        if (chartRef.current) {
            const { chart } = chartRef.current as {
                chart: Highcharts.Chart
            }
            chart.reflow()
        }
    }, [width, height])

    return (
        <Container theme={valueContext?.theme}>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={Coptions} />
        </Container>
    )
}

export default SolidGauge

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    > div:last-child,
    .highcharts-container {
        width: 100% !important;
        height: 100% !important;
    }
`
